"use client";

import { useSyncExternalStore } from "react";

// Returns `serverDefault` during SSR and the first hydration render, then the
// live value.
export function useMediaQuery(query: string, serverDefault = false): boolean {
  return useSyncExternalStore(
    (callback) => {
      const mq = window.matchMedia(query);
      mq.addEventListener("change", callback);
      return () => mq.removeEventListener("change", callback);
    },
    () => window.matchMedia(query).matches,
    () => serverDefault,
  );
}
